import { createSlice } from "@reduxjs/toolkit";
import { nonprofitProfileListAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const nonprofitProfileSlice = createSlice({
  name: "nonprofitProfile",
  initialState: data,
  reducers: {
    nonprofitProfileSlice(state) {
      state.isLoading = true;
    },
    nonprofitProfileSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    nonprofitProfileSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    nonprofitProfileSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const nonprofitProfileHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(nonprofitProfileAction.nonprofitProfileSlice());
    const response: any = await nonprofitProfileListAPI(id);
    dispatch(nonprofitProfileAction.nonprofitProfileSliceSuccess(response));
  } catch (e: any) {
    dispatch(nonprofitProfileAction.nonprofitProfileSliceFailure(e?.response?.data?.message));
    dispatch(nonprofitProfileAction.nonprofitProfileSliceReset());
  }
};
export default nonprofitProfileSlice.reducer;
export const nonprofitProfileAction = nonprofitProfileSlice.actions;
